"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectPageType = void 0;
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var pagetype_config_1 = require("./pagetype_config");
/**
 * 选择页面类型
 * @param props
 * @returns
 */
function SelectPageType() {
    var location = (0, react_router_dom_1.useLocation)();
    var pathname = location.pathname.toLowerCase();
    if (window.mainpath == 'center') {
        pathname = pathname.replace("/center/", "/");
    }
    else if (window.mainpath == 'center2') {
        pathname = pathname.replace("/center2/", "/");
    }
    // console.log('pathname:'+ pathname)
    var hash = location.hash.toLowerCase();
    var hash_no_sharp = hash;
    if (hash_no_sharp.substring(0, 1) == '#') {
        hash_no_sharp = hash_no_sharp.substring(1);
    }
    for (var i = 0; i < pagetype_config_1.PageRouterConfig.length; i++) {
        var item = pagetype_config_1.PageRouterConfig[i];
        if (item.path.some(function (v) {
            //商品期权
            if (!!/#options_\d+_\d+$/.test(hash) && v == '/gridlist.html#options_{market}_{type}') {
                return true;
            }
            // 期货-子品种
            if (!!/#futures_\d+_\d+$/.test(hash) && v == '/gridlist.html#futures_{d}_{d}') {
                return true;
            }
            // 板块-子板块
            if (!!/^#boards2\-90\.(bk|BK)\d+$/.test(hash) && v == '/gridlist.html#boards2-90.bk{d}') {
                return true;
            }
            if (v.indexOf('#') > -1) { //有限定hash
                return v == (pathname + hash);
            }
            else { //不限定hash
                return v == pathname;
            }
        })) {
            return item.page;
        }
    }
    /** 兜底跳转到沪深京首页 */
    return (react_1.default.createElement(react_router_dom_1.Redirect, { from: '*', to: "/".concat(window.mainpath, "/gridlist.html#hs_a_board") }));
}
exports.SelectPageType = SelectPageType;
